<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">Solicitud Pago</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="6" lg="3" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <ListadoDetallesSolicitudesPagos
              ref="listadoRef"
              :items="item.detallesSolicitudesPagos"
              :cargando="false"
              :sonPagosUniversidad="true"
              :mostrarColumnaCuotaAnterior="true"
              :detallePagoConceptoUniversidadCuotaAnterior="detallePagoConceptoUniversidadCuotaAnterior"
              :inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior="
                inscripcionesProgramasUniversidadesPagadasDeCuotaAnterior
              " />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListadoDetallesSolicitudesPagos from './ListadoDetallesSolicitudesPagos.vue';
import ListadoItem from './ListadoItem.vue';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import cuotaAnteriorMixin from '../mixins/cuota-anterior.mixin';
import { formatearValorAMoneda } from '../utils/funciones';

export default {
  name: 'ModalMostrarSolicitudPago',
  mixins: [apiConsumerMixin, cuotaAnteriorMixin],
  components: {
    ListadoDetallesSolicitudesPagos,
    ListadoItem,
  },
  data() {
    return {
      visible: false,
      item: this.generarObjetoFormRegistrar(),
    };
  },
  computed: {
    numeroEstudiantes() {
      return this.item.detallesSolicitudesPagos.length;
    },
    montoTotal() {
      return (this.item?.monto * this.numeroEstudiantes).toFixed(2);
    },
    listado() {
      return [
        { nombre: 'N° Solicitud', valor: this.item.numeroSolicitud },
        { nombre: 'Fecha Solicitud', valor: this.item.fechaSolicitud },
        {
          nombre: 'Concepto',
          valor:
            this.item?.detallePlanPagoConceptoUniversidad?.planPagoConceptoUniversidad?.conceptoUniversidad?.concepto
              ?.nombre,
        },
        { nombre: 'Monto', valor: formatearValorAMoneda(this.item?.monto) },
        { nombre: 'N° Estudiantes', valor: this.numeroEstudiantes },
        { nombre: 'Monto Total', valor: formatearValorAMoneda(this.montoTotal) },
        { nombre: 'Solicitado por', valor: this.item.nombreSolicitante },
        { nombre: 'Creado en', valor: this.item.creadoEn },
      ];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        programaUniversidadId: null,
        numeroSolicitud: null,
        fechaSolicitud: null,
        conceptoUniversidadId: null,
        conceptoUniversidad: null,
        monto: null,
        creadoEn: null,
        actualizadoEn: null,
        nombreSolicitante: null,
        detallesSolicitudesPagos: [],
        detallePlanPagoConceptoUniversidad: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        programaUniversidadId: data.programaUniversidadId,
        numeroSolicitud: data.numeroSolicitud,
        fechaSolicitud: data.fechaSolicitud,
        conceptoUniversidadId: data.conceptoUniversidadId,
        conceptoUniversidad: data.conceptoUniversidad,
        monto: data.monto,
        creadoEn: data.creadoEn,
        actualizadoEn: data.actualizadoEn,
        nombreSolicitante: data.nombreSolicitante,
        detallesSolicitudesPagos: data.detallesSolicitudesPagos,
        detallePlanPagoConceptoUniversidad: data.detallePlanPagoConceptoUniversidad,
      };
    },
    abrir(data = null) {
      this.item = this.generarObjetoFormEditar(data);

      const planPagoUniversidadId =
        this.item?.detallePlanPagoConceptoUniversidad?.planPagoConceptoUniversidad?.planPagoUniversidad?.id;
      const detallePlanPagoConceptoUniversidadId = this.item?.detallePlanPagoConceptoUniversidad?.id;

      Promise.all([
        this.obtenerDetallePagoConceptoUniversidadCuotaAnterior(
          planPagoUniversidadId,
          detallePlanPagoConceptoUniversidadId,
        ),
        this.obtenerPagosUniversidadesCuotaAnterior(planPagoUniversidadId, detallePlanPagoConceptoUniversidadId),
      ]).then(() => {
        this.visible = true;
      });
    },
    cerrar() {
      this.visible = false;
    },
  },
};
</script>